import { ReactComponent as InterruptedByErrorIconSvg } from "../../images/command-hub/InterruptedByErrorIcon.svg";
import { SvgIcon, SvgIconProps } from "@mui/material";

const InterruptedByErrorIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon component={InterruptedByErrorIconSvg} {...props} inheritViewBox />
);

export default InterruptedByErrorIcon;
